module.exports = __webpack_public_path__ + "static/media/people-handshake-mob.73ab39ed.jpg";